// The weight-stepper magnitudes, in one place.
//
// FocusPanelInputs (strength) and FocusPanelTimed (the added load on a hold)
// each used to declare these, and FocusPanelTimed's comment asked the next
// reader to keep them in sync by hand. A hold's added load must step exactly
// like a normal exercise's weight, so that agreement is now structural.
//
// The values are the plate/dumbbell increments the athlete actually meets:
// 0.5kg is the smallest microplate pair, 1.25/2.5/5 the standard plates. The
// lb column starts one notch up because there is no half-pound plate.
export const STEPS_KG = [0.5, 1.25, 2.5, 5];
export const STEPS_LB = [1.25, 2.5, 5, 10];

// PE-34 — a PRESCRIBED %MAX is not loaded off a rack, so plate increments are
// the wrong ladder for it: whole points are the moves a coach actually makes
// when writing a mesocycle (70 → 75 → 80).
export const STEPS_PERCENT = [1, 2.5, 5, 10];
